export const comments = [
  {
    uuid: '3bfc861b-3ce1-489a-97ea-fb4b20ddd832',
    text: 'لطفا از داروهای جدید استفاده کنید. 😮☺',
    created_at: 1641568480,
    user_uuid: 'ec4de62a-cecc-40e8-b066-8a7297633d3c',
    test_uuid: 'f39f5f4a-1aee-470a-8a39-97b16f326db4',
    type: 'text'
  },
  {
    uuid: '3bfc861b-3ce1-489a-97ea-fb4b20ddd832',
    text: 'این یک نمونه طولانی برای درخواست از کاربر برای مراجعه به مطب پزشک می باشد. این یک نمونه طولانی برای درخواست از کاربر برای مراجعه به مطب پزشک می باشد.',
    created_at: 1641568480,
    user_uuid: 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    test_uuid: 'f39f5f4a-1aee-470a-8a39-97b16f326db4',
    type: 'text'
  },
  {
    uuid: '3bfc861b-3ce1-489a-97ea-fb4b20ddd832',
    text: 'یک نمونه دیگر',
    created_at: 1641568494,
    user_uuid: 'ec4de62a-cecc-40e8-b066-8a7297633d3c',
    test_uuid: 'f39f5f4a-1aee-470a-8a39-97b16f326db4',
    type: 'text'
  },
  {
    uuid: '3bfc861b-3ce1-489a-97ea-fb4b20ddd832',
    text: 'نمونه پیام',
    created_at: 1641568498,
    user_uuid: 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    test_uuid: 'f39f5f4a-1aee-470a-8a39-97b16f326db4',
    type: 'text'
  },
  {
    uuid: '3bfc861b-3ce1-489a-97ea-fb4b20ddd832',
    // eslint-disable-next-line no-multi-str
    text: `| نام | توضیحات |\r\n\
| --------:| -----------:|\r\n\
| استامینوفن   | هر 8 ساعت |\r\n\
| مفنامیک اسید | روزی یکبار |\r\n\
| شربت سینه    | قبل از غذا |`,
    created_at: 1641569599,
    user_uuid: 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    test_uuid: 'f39f5f4a-1aee-470a-8a39-97b16f326db4',
    type: 'md'
  }
]



// WEBPACK FOOTER //
// ./src/_helpers/backend-data/comments.js